import { BaseSubmitAction, BaseSubmitProps, ExecutionResult } from '../../BaseSubmitAction';
import {
  AffiliateContext,
  AffiliateDispatchAction,
  ProductPricing,
} from 'lib/context/AffiliateContext';

export class GetPricingData extends BaseSubmitAction {
  constructor(params: BaseSubmitProps) {
    super(params);
  }

  override async executeAction(): Promise<ExecutionResult> {
    const affiliateContext = this.context as AffiliateContext;
    const affiliateId = affiliateContext.userAffiliate.affiliateId;

    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      // body is not needed for GET request
    };

    return fetch(
      `/api/rba/submit-actions/get-pricing-data?affiliateId=${affiliateId}`,
      requestOptions
    )
      .then(async (response) => {
        const { data } = await response.json();
        const dispatchAction: AffiliateDispatchAction = {
          result: {
            affiliatePricing: data[0]?.affiliatePricing as ProductPricing[],
          },
          type: 'getPricingData',
        };

        return new Promise<ExecutionResult>((resolve) => {
          resolve({
            result: dispatchAction,
            success: data !== null ? true : false,
            errorMessage: this.actionFieldsProps?.errorMessage?.value,
          });
        });
      })
      .catch((error) => {
        console.error(`${error.message}`);
        return new Promise<ExecutionResult>((resolve) => {
          resolve({
            success: false,
            errorMessage: this.actionFieldsProps?.errorMessage?.value,
          });
        });
      });
  }
}
